import React from 'react';
import { HTMLRenderer } from './HTMLRenderer';
import { TEXT_TYPE } from '../../constants';

const ElementsRenderer = (props) => {
  const { elements, textType = TEXT_TYPE.PLAIN, variant, wrapperClassName } = props;
  if (elements?.length > 0) {
    const content = elements.map((e) => (
      <HTMLRenderer
        element={e}
        key={e.id}
        variant={variant}
        textType={e.type === 'textbox' ? textType : undefined}
      />
    ));

    if (wrapperClassName || variant === 'welcome') {
      return <div className={wrapperClassName || 'space-y-4'}>{content}</div>;
    }

    return <div>{content}</div>;
  }
  return null;
};

export { ElementsRenderer };
